import React from 'react';

interface ProRecommendationProps {
  rowData: any[];
}

const ProRecommendation: React.FC<ProRecommendationProps> = ({ rowData }) => {
  if (rowData && rowData.length < 1000) return null;

  return (
    <div className="calendar-table__pro-wrapper">
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href="https://pro.benzinga.com" target="_blank">
        Access All Recommendation in Pro <i className="fa fa-chevron-right" />
      </a>
    </div>
  );
};

export default ProRecommendation;
